import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const RadioButtonUnchecked = createSvgIcon(
  <path d="M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2m0-2A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z" />,
  'RadioButtonUnchecked'
);

export { RadioButtonUnchecked };